<template>
  <tr>
    <td v-for="(header, index) in visibleHeaders" :key="index">
      <component
        :is="fields[header.value].component"
        v-if="
          header.value &&
          fields[header.value] &&
          !fields[header.value].isGlobalFilter
        "
        v-bind="fields[header.value].attributes"
        :key="header.value"
        :field-name="fields[header.value].name || header.value"
        :field-names-map="fields[header.value].fieldNamesMap"
        v-on="fields[header.value].listeners"
        @search="
          (search) =>
            fields[header.value].offline
              ? handleOfflineSearch(search)
              : handleSearch(search)
        "
      ></component>
    </td>
  </tr>
</template>

<script>
import { debounce } from "@evercam/shared/utils"
import TextFieldSearchFilter from "@/components/searchFilters/TextFieldSearchFilter"
import SelectSearchFilter from "@/components/searchFilters/SelectSearchFilter"
import DatePickerSearchFilter from "@/components/searchFilters/DatePickerSearchFilter"
import DatePickerRangeSearchFilter from "@/components/searchFilters/DatePickerRangeSearchFilter"
import SelectDatePickerRangeSearchFilter from "@/components/searchFilters/SelectDatePickerRangeSearchFilter"
import CountFieldSearchFilter from "@/components/searchFilters/CountFieldSearchFilter"
import TagSearchFilter from "@/components/searchFilters/TagSearchFilter.vue"
import { mapStores } from "pinia"
import { useReportStore } from "@/stores/report"

export default {
  components: {
    TextFieldSearchFilter,
    SelectSearchFilter,
    DatePickerSearchFilter,
    DatePickerRangeSearchFilter,
    SelectDatePickerRangeSearchFilter,
    CountFieldSearchFilter,
    TagSearchFilter,
  },
  props: {
    filterFields: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchParams: {},
    }
  },
  computed: {
    ...mapStores(useReportStore),
    fields() {
      return this.filterFields
    },
    visibleHeaders() {
      const emptyHeaders = this.reportStore.selectedHeaders.filter(
        (h) => !Object.keys(h).length
      )
      const orderedVisibleHeaders = this.headers.filter((h) =>
        this.reportStore.selectedHeaders.includes(h)
      )

      return [...emptyHeaders, ...orderedVisibleHeaders]
    },
  },
  watch: {
    "reportStore.searchFilters"(value) {
      this.searchParams = value
    },
  },
  created() {
    this.reportStore.offlineSearchParams = Object.fromEntries(
      Object.entries(this.filterFields)
        .filter(([_, field]) => field.offline)
        .map(([field, { attributes }]) => [field, attributes?.value])
        .filter(
          ([_, value]) =>
            (Array.isArray(value) && !!value?.length) ||
            !["", null, undefined].includes(value)
        )
    )
  },
  methods: {
    handleSearch(change) {
      this.searchParams = {
        ...this.searchParams,
        ...change,
      }
      this.fireFilter(this)
    },
    handleOfflineSearch: debounce(function (search) {
      this.reportStore.offlineSearchParams = {
        ...this.reportStore.offlineSearchParams,
        ...search,
      }
    }, 200),
    fireFilter: debounce(function (self) {
      this.$emit("update-search-filters", self.searchParams)
    }, 500),
  },
}
</script>
